export const drawerWidthExpanded = 210;
export const drawerWidthExpandedMobile = 250;
export const drawerWidth = 80;
export const drawerNestedMenuWidth = 300;
export const navigationBarHeight = 64;
export const appLoaderHeight = 4;

const layoutHiddenPages = ["user-role-guide"];
export const hideLayoutPage = path =>
  !layoutHiddenPages.find(page => path?.includes(page));
